var React = require('react');

function LeftCorner (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.320312 6.56445C0.320312 6.84473 0.422852 7.07715 0.648438 7.2959L5.91211 12.4434C6.08301 12.6211 6.30176 12.71 6.55469 12.71C7.06738 12.71 7.47754 12.2998 7.47754 11.7871C7.47754 11.5273 7.375 11.3018 7.19043 11.1172L2.51465 6.55762L7.19043 2.01172C7.375 1.82715 7.47754 1.59473 7.47754 1.3418C7.47754 0.829102 7.06738 0.425781 6.55469 0.425781C6.29492 0.425781 6.08301 0.507812 5.91211 0.685547L0.648438 5.83301C0.422852 6.05176 0.327148 6.28418 0.320312 6.56445Z","fill":"#222224"}));
}

LeftCorner.defaultProps = {"width":"8","height":"13","viewBox":"0 0 8 13","fill":"none"};

module.exports = LeftCorner;

LeftCorner.default = LeftCorner;
